import { DesignSystemLegacy } from '@change-corgi/design-system-legacy/core';
import { createModalHook } from '@change-corgi/design-system-legacy/modals';
import { sunriseTheme } from '@change-corgi/design-system-legacy/theme';

import { EducationModal } from './components/EducationModal';
import { EducationModalHeading } from './components/EducationModalHeading';

export type UseTiktokEducationModalPropsDefault = {
	onContinueAction: () => Promise<void>;
};

type UseTiktokEducationModalProps = UseTiktokEducationModalPropsDefault & {
	isSunriseEnabled: boolean;
};

export const useTiktokEducationModal = createModalHook<UseTiktokEducationModalProps, { successfulShare: boolean }>({
	name: 'TiktokShareEducationModal',
	heading: function EducationModalHead({ options: { isSunriseEnabled } }) {
		return (
			<DesignSystemLegacy theme={isSunriseEnabled ? sunriseTheme : undefined}>
				<EducationModalHeading isSunriseEnabled={isSunriseEnabled} />
			</DesignSystemLegacy>
		);
	},
	body: function EducationModalBody({ options: { onContinueAction, isSunriseEnabled }, closeModal }) {
		return (
			<DesignSystemLegacy theme={isSunriseEnabled ? sunriseTheme : undefined}>
				<EducationModal
					onContinue={async () => {
						await onContinueAction();
						closeModal({ successfulShare: true });
					}}
				/>
			</DesignSystemLegacy>
		);
	},
	// if share attempt is done within another modal, we need to kill that modal
	// to avoid multiple layers of modals
	killOpenModal: true,
});
